import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { SubmitCancelForm } from "./SubmitCancelForm";
import Progress from "./Progress";
import { DropzoneArea } from "material-ui-dropzone";

type ImportProps = {
    isOpen: boolean;
    isLoading: boolean;
    close: () => void;
    save: (files: Array<File>) => Promise<void>;
};

export const LicenseImport = observer((props: ImportProps) => {
    const {isOpen, isLoading, close, save} = props;
    const [files, setFiles] = useState<Array<File>>([]);

    return (
        <SubmitCancelForm
            title="Импорт файла с лицензией"
            subTitle="Ожидаемые форматы: json"
            isOpen={isOpen}
            close={close}
            save={async () => { 
                await save(files);
                close();
            }}
        >
            <DropzoneArea
                acceptedFiles={['.json']}
                dropzoneText="Перетащите файлы мышью или нажмите для выбора"
                showFileNames
                filesLimit= {1}
                onChange={(fs) => setFiles(fs)}
            />
            <Progress isLoading={isLoading}/>
        </SubmitCancelForm>
    );
});